import axios from 'axios';

export default {
    data: () => ({
        order: null,
        products: null
    }),
    computed: {
        storage: function () {
            return this.$contact != null ? "database" : "cookie";
        }
    },
    created() {
        this.$eventHub.$on('productAttaced', this.attachProduct);
    },
    methods: {
        attachProduct(product) {
            if (this.order && this.products) this.getOrder();
        },
        addToCart(payload, refresh = true) {
            let presentation = payload.product.presentations.find(x => parseInt(x.price) == parseInt(payload.config.price))
            payload.config.has_variation = presentation ? {
                presentation: presentation.presentation,
                price: payload.config.price
            } : null;

            if (this.storage == "database") {
                this.submit(payload, refresh);
            } else {
                this.updateOrCreateCookie(payload, refresh);
            }
        },
        submit(payload, refresh) {
            axios.post('/api/contact/v1/orders/attach-item', {
                data: {
                    product_id: payload.product._id,
                    config: payload.config
                }
            }, {
                headers: {
                    "x-api-key": "NPP3dB1ch8CiEmRGprtB2Vpr7xbZdA7iUnw7gX7ORjXdX0vzQ"
                }
            }).then(response => {
                this.$awn.success('¡Producto agregado!');
                if (refresh) {
                    setTimeout(() => {
                        window.location.href = "/productos"
                    }, 1000)
                } else {
                    this.$eventHub.$emit('productAttaced');
                }
            }).catch(error => {
                this.$awn.warning('Error del servidor');
            });
        },
        getOrder() {
            axios.get(`/api/${this.storage == 'database' ? 'contact' : 'public'}/v1/orders/current-order`, {
                headers: {
                    "x-api-key": "NPP3dB1ch8CiEmRGprtB2Vpr7xbZdA7iUnw7gX7ORjXdX0vzQ"
                }
            }).then(response => {
                this.order = response.data.data;
                this.products = response.data.products;
            }).catch(error => {
                this.$awn.warning('Error al obtener su orden');
            });
        },
        detachProduct(product) {
            axios.put(`/api/${this.storage == 'database' ? 'contact' : 'public'}/v1/orders/dettach-item`, {
                data: {
                    product_id: product._id
                }
            }, {
                headers: {
                    "x-api-key": "NPP3dB1ch8CiEmRGprtB2Vpr7xbZdA7iUnw7gX7ORjXdX0vzQ"
                }
            }).then(response => {
                let index = this.products.findIndex(x => x._id == product._id);
                if (index != -1) {
                    this.products.splice(index, 1)
                }
                this.$awn.success('Producto eliminado');
            }).catch(error => {
                this.$awn.warning('Error al eliminar el producto');
            });
        },
        confirmOrder() {
            axios.put('/api/contact/v1/orders/confirm-order', {}, {
                headers: {
                    "x-api-key": "NPP3dB1ch8CiEmRGprtB2Vpr7xbZdA7iUnw7gX7ORjXdX0vzQ"
                }
            }).then(response => {
                this.order = null;
                this.products = null;
                this.$awn.success('Orden confirmada');
            }).catch(error => {
                this.$awn.warning('Error al eliminar el producto');
            });
        },
        getConfig(id) {
            return this.order && this.order.config && this.order.config[id] ? this.order.config[id] : null;
        },
        getPrice(id) {
            let config = this.getConfig(id);

            if (config && config.has_variation) {
                return config.has_variation.price;
            } else if (config) {
                return config.price;
            } else {
                return 0;
            }
        },
        getQuantity(id) {
            let config = this.getConfig(id);
            return config ? config.quantity : 0;
        },
        getTotal(id) {
            let config = this.getConfig(id);
            return config ? config.total : 0;
        },
        // When data comes from cookie
        updateOrCreateCookie(payload, refresh) {
            axios.post('/api/public/v1/orders/attach-item', {
                data: {
                    product: payload['product'],
                    config: payload['config']
                }
            }, {
                headers: {
                    "x-api-key": "NPP3dB1ch8CiEmRGprtB2Vpr7xbZdA7iUnw7gX7ORjXdX0vzQ"
                }
            }).then(response => {
                if (refresh) {
                    setTimeout(() => {
                        window.location.href = "/productos"
                    }, 1000)
                } else {
                    this.$eventHub.$emit('productAttaced');
                }
                this.$awn.success('Producto agregado');
            }).catch(error => {
                this.$awn.warning('Error al agregar el producto');
            });
        }
    }
}